import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { WALLPAPER, OFFICES } from "../data/content";

export const GlobalPresence = () => {
  const { t } = useLang();
  return (
    <section id="global" className="media-dark relative py-24 lg:py-32 overflow-hidden" data-testid="global-section">
      <div className="absolute inset-0">
        <img src={WALLPAPER} alt="" className="w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#030305] via-[#030305]/50 to-[#030305]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <div className="text-xs tracking-[0.2em] uppercase font-mono text-cyan mb-4">{t("global_eyebrow")}</div>
          <h2 className="font-head font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">{t("global_title")}</h2>
          <p className="mt-5 text-base text-zinc-300 leading-relaxed">{t("global_subtitle")}</p>
        </motion.div>

        <div className="mt-12 flex flex-wrap gap-3">
          {OFFICES.map((city, i) => (
            <motion.span
              key={city}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.05 }}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass border border-[#00F0FF]/25 text-sm font-mono text-zinc-200"
              data-testid={`office-${i}`}
            >
              <MapPin size={14} className="text-cyan" />
              {city}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
};
